import { combineReducers } from 'redux';

import imprint from './imprint/reducer';

export default combineReducers({
  imprint,
});
